import React, { useState } from 'react';
import '../CRMProfileScreen.css';

const HAMSTIRResultsModal = ({ isOpen, onClose, results, onApplyData, isNewProfile, profileData }) => {
    const [applyingData, setApplyingData] = useState(false);

    if (!isOpen || !results) return null;

    const handleApplySummary = async () => {
        setApplyingData(true);
        try {
            await onApplyData(results);
        } finally {
            setApplyingData(false);
        }
    };

    const handleClose = () => {
        onClose();
    };

    return (
        <div className="modal-overlay" style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000
        }}>
            <div className="modal-content" style={{
                backgroundColor: 'white',
                borderRadius: '12px',
                padding: '2rem',
                minWidth: '800px',
                maxWidth: '90vw',
                maxHeight: '80vh',
                overflow: 'auto',
                boxShadow: '0 10px 25px rgba(0, 0, 0, 0.15)'
            }}>
                <div className="modal-header" style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '1.5rem',
                    paddingBottom: '1rem',
                    borderBottom: '1px solid #e5e7eb'
                }}>
                    <h3 style={{ 
                        margin: 0, 
                        color: '#4a6b25', 
                        fontSize: '1.25rem', 
                        fontWeight: '600',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem'
                    }}>
                        Partner Overview Summary
                    </h3>
                    <button
                        onClick={handleClose}
                        style={{
                            background: 'none',
                            border: 'none',
                            fontSize: '1.5rem',
                            cursor: 'pointer',
                            color: '#6b7280',
                            padding: '0.25rem'
                        }}
                    >
                        ×
                    </button>
                </div>

                <div className="modal-body">
                    {/* Info Section */}
                    <div style={{
                        padding: '1rem',
                        backgroundColor: '#f0f9ff',
                        border: '1px solid #bfdbfe',
                        borderRadius: '8px',
                        marginBottom: '1.5rem'
                    }}>
                        <div style={{ fontSize: '0.875rem', color: '#1e40af' }}>
                            <strong>Partner Profile Summary Generated:</strong> Review the comprehensive summary below and click "Apply Summary" to 
                            {(!profileData?.id || isNewProfile) 
                                ? ' add it to your partner profile form. You will need to save the profile to persist this data.'
                                : ' save it to your partner profile. The summary will be displayed on the partner profile page.'
                            }
                        </div>
                    </div>

                    {/* Summary Display */}
                    <div className="summary-container">
                        <div className="summary-section" style={{ marginBottom: '2rem' }}>
                            <h4 style={{ 
                                color: '#4a6b25', 
                                marginBottom: '1rem',
                                fontSize: '1.1rem',
                                fontWeight: '600',
                                borderBottom: '2px solid #e5e7eb',
                                paddingBottom: '0.5rem'
                            }}>
                                Generated Partner Overview Summary
                            </h4>
                            
                            <div className="summary-content" style={{
                                border: '1px solid #e5e7eb',
                                borderRadius: '8px',
                                padding: '1.5rem',
                                backgroundColor: '#ffffff',
                                fontSize: '0.925rem',
                                lineHeight: '1.4',
                                color: '#374151',
                                fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif',
                                maxHeight: '400px',
                                overflowY: 'auto'
                            }}>
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: results
                                            .replace(/## (.+)/g, '<h4 style="color: #4a6b25; font-weight: 600; margin: 0.75rem 0 0.25rem 0; font-size: 1.1rem;">$1</h4>')
                                            .replace(/### (.+)/g, '<h5 style="color: #5a7b35; font-weight: 600; margin: 0.5rem 0 0.15rem 0; font-size: 1rem;">$1</h5>')
                                            .replace(/- \*\*(.+?):\*\* (.+)/g, '<div style="margin: 0.1rem 0; padding-left: 1rem;"><strong style="color: #374151;">$1:</strong> $2</div>')
                                            .replace(/- (.+)/g, '<div style="margin: 0.1rem 0; padding-left: 1rem;">• $1</div>')
                                            .replace(/\*\*(.+?)\*\*/g, '<strong style="color: #374151;">$1</strong>')
                                            .replace(/\n\n/g, '<div style="margin: 0.3rem 0;"></div>')
                                            .replace(/\n/g, '<br/>')
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal-footer" style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    paddingTop: '1rem',
                    borderTop: '1px solid #e5e7eb'
                }}>
                    <div style={{ fontSize: '0.875rem', color: '#6b7280' }}>
                        {(!profileData?.id || isNewProfile) 
                            ? 'Summary ready to apply to form (profile not saved yet)'
                            : 'Summary ready to apply to partner profile'
                        }
                    </div>
                    
                    <div style={{ display: 'flex', gap: '1rem' }}>
                        <button
                            onClick={handleClose}
                            disabled={applyingData}
                            style={{
                                background: 'transparent',
                                border: '1px solid #d1d5db',
                                color: '#374151',
                                borderRadius: '8px',
                                padding: '0.75rem 1.5rem',
                                fontSize: '0.875rem',
                                fontWeight: '600',
                                cursor: applyingData ? 'not-allowed' : 'pointer',
                                opacity: applyingData ? 0.6 : 1,
                                transition: 'all 0.2s'
                            }}
                        >
                            Cancel
                        </button>
                        <button
                            onClick={handleApplySummary}
                            disabled={applyingData}
                            style={{
                                background: applyingData 
                                    ? '#6c757d' 
                                    : 'linear-gradient(135deg, #4a6b25, #3a5b15)',
                                color: 'white',
                                border: 'none',
                                borderRadius: '8px',
                                padding: '0.75rem 1.5rem',
                                fontSize: '0.875rem',
                                fontWeight: '600',
                                cursor: applyingData ? 'not-allowed' : 'pointer',
                                opacity: applyingData ? 0.6 : 1,
                                transition: 'all 0.2s',
                                boxShadow: applyingData 
                                    ? 'none' 
                                    : '0 2px 4px rgba(74, 107, 37, 0.25)'
                            }}
                        >
                            {applyingData 
                                ? 'Applying Summary...' 
                                : (!profileData?.id || isNewProfile) 
                                    ? 'Apply Summary to Form' 
                                    : 'Apply Summary to Profile'
                            }
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HAMSTIRResultsModal; 